import colors from "../../Theme/base/colors";
// import typography from "../../Theme/base/typography";
import pxToRem from "../../Theme/functions/pxToRem";

const { brand, error } = colors;

export default {
  base: {
    height: pxToRem(36),
    color: colors.text.labelWhite,
    boxShadow: "none",
    alignitem: "center",
  },
  small: {
    // minWidth: pxToRem(160),
    height: pxToRem(28),
    alignitem: "center",
    fontSize: pxToRem(12),
    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
    padding: "6px 12px !important",
  },

  medium: {
    // minWidth: pxToRem(240),
    height: pxToRem(36),
    padding: "10px 16px !important",
    alignitem: "center",
    fontSize: pxToRem(14),

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    height: pxToRem(40),
    alignitem: "center",
    fontSize: pxToRem(16),
    padding: "12px 24px !important",
    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  fullWidth: {
    minHeight: pxToRem(36),
    width: "100%",
    padding: `12px 24px 12px 24px`,
    fontSize: pxToRem(14),

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  primary: {
    backgroundColor: brand.main,

    border: "none",
    "&:hover": {
      backgroundColor: brand.medium,
    },

    "&:focus:not(:hover)": {
      backgroundColor: brand.main,
    },
    "&:disabled": {
      backgroundColor: brand.disabled,
    },
  },
  error: {
    backgroundColor: error.main,

    border: "none",
    "&:hover": {
      backgroundColor: error.medium,
    },

    "&:focus:not(:hover)": {
      backgroundColor: error.main,
    },
    "&:disabled": {
      backgroundColor: error.disabled,
    },
  },
};
